import React, { useState } from 'react';
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './PaymentForm.css';
import { API_URL } from '../utils/networkConfig';

const PaymentForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate();
  const location = useLocation();
  const [processing, setProcessing] = useState(false);
  const [error, setError] = useState('');
  const [paymentSucceeded, setPaymentSucceeded] = useState(false);

  // Get question data from navigation state
  const { question, gameSessionId } = location.state || {};

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!stripe || !elements) {
      return;
    }

    if (!question || !gameSessionId) {
      setError('Missing payment information. Please go back and try again.');
      return;
    }

    setProcessing(true);
    setError('');

    try {
      // Create payment intent
      const response = await axios.post(`${API_URL}/api/game-sessions/create-payment-intent`, {
        amount: 2000, // $20.00 in cents
        currency: 'usd',
      });

      const { clientSecret } = response.data;

      // Confirm payment
      const { error: stripeError, paymentIntent } = await stripe.confirmCardPayment(clientSecret, {
        payment_method: {
          card: elements.getElement(CardElement),
        }
      });

      if (stripeError) {
        setError(stripeError.message);
      } else if (paymentIntent.status === 'succeeded') {
        // Payment successful
        console.log('Payment succeeded!');
        
        // Send confirmation to backend
        await axios.post(`${API_URL}/api/game-sessions/confirm-payment`, {
          paymentIntentId: paymentIntent.id,
        });

        // Redirect to success page
        navigate('/success');
      }
    } catch (err) {
      console.error('Payment error:', err);
      setError('Payment failed. Please try again.');
    } finally {
      setProcessing(false);
    }
  };

  if (paymentSucceeded) {
    return (
      <div className="payment-success">
        <h2>Payment Successful!</h2>
        <p>Your payment has been processed. You can now answer the question.</p>
        <p>Redirecting you back to the game...</p>
      </div>
    );
  }

  return (
    <div className="payment-form-container">
      <div className="payment-form">
        <h2>Complete Your Payment</h2>
        
        {question && (
          <div className="question-preview">
            <h3>Question:</h3>
            <p>{question.question_text}</p>
            <p><strong>Entry Fee: $0.50</strong></p>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="card-element-container">
            <label htmlFor="card-element">Credit or Debit Card</label>
            <CardElement
              id="card-element"
              options={{
                style: {
                  base: {
                    fontSize: '16px',
                    color: '#424770',
                    '::placeholder': {
                      color: '#aab7c4',
                    },
                  },
                  invalid: {
                    color: '#9e2146',
                  },
                },
              }}
            />
          </div>

          {error && (
            <div className="error-message">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={!stripe || processing}
            className="pay-button"
          >
            {processing ? 'Processing...' : 'Pay $0.50'}
          </button>
        </form>

        <button 
          className="back-button"
          onClick={() => navigate('/')}
        >
          Back to Questions
        </button>
      </div>
    </div>
  );
};

export default PaymentForm; 